import { InfosPSBENState, InfosPSBEN } from './types';
import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { getInfosPSBEN2 } from '@/services/api/psben2/api';
import _ from 'lodash';

const namespaced: boolean = true;

export const state: InfosPSBENState = {
	infosPSBEN: undefined,
	error: false,
	loaded: false
};

export const mutations: MutationTree<InfosPSBENState> = {
	updateInfosPSBEN(state: InfosPSBENState, infosPSBEN: InfosPSBEN): void {
		state.infosPSBEN = infosPSBEN;
	},
	updateErrorInfosPSBEN(state: InfosPSBENState, error: boolean): void {
		state.error = error;
	},
	updateLoaded(state: InfosPSBENState, loaded: boolean): void {
		state.loaded = loaded;
	}
};

export const actions: ActionTree<InfosPSBENState, RootState> = {
	fetchInfosPSBEN(state): Promise<void> {
		return new Promise((resolve, reject) => {
			return getInfosPSBEN2()
				.then((response: any) => {
					const infosPSBEN: InfosPSBEN = new InfosPSBEN(_.get(response, 'data.value'));
					const infosAssure = infosPSBEN?.infosASSURE;
					const infosBenef = infosPSBEN?.infosBENEF;
					const nir: string | undefined = infosBenef?.nir !== '' ? infosBenef?.nir : infosAssure?.nir;
					const isFeminin: boolean = !_.isEmpty(nir) && nir !== undefined && nir.startsWith('2');
					const assure: boolean = isAssure(infosAssure?.nir, infosBenef?.nir,
						infosAssure?.dateNaissance, infosBenef?.dateNaissance);

					const patient = getPatient(infosAssure, infosBenef, isFeminin, assure, nir);
					state.dispatch('patient/updatePatient', patient, { root: true });

					const reqParamsRegimeCaisse = {
						codeRegime: infosPSBEN.infosASSURE.codeRegime,
						codeCaisse: infosPSBEN.infosASSURE.codeCaisse,
						codeCentre: infosPSBEN.infosASSURE.codeCentre
					};
					state.dispatch('regimeCaisse/fetchRegimeCaisse', reqParamsRegimeCaisse, { root: true }).then(() => {
						state.commit('updateInfosPSBEN', infosPSBEN);
						state.commit('updateLoaded', true);
					});

					resolve();
				})
				.catch((error: any) => {
					state.commit('updateLoaded', true);
					state.commit('updateErrorInfosPSBEN', true);
					reject();
				});
		});
	}
};

function isAssure(
	nirAssure: string | undefined,
	nirBenef: string | undefined,
	dateNaissanceAssure: string| undefined,
	dateNaissanceBenef: string | undefined
) {
	const isSameNir: boolean = (nirBenef === '') || (nirAssure === nirBenef);
	const isSameDate: boolean = dateNaissanceAssure === dateNaissanceBenef;
	return isSameNir && isSameDate;
}

function getPatientStatut(nir: string, assure: boolean, isFeminin: boolean) {
	if (_.isEmpty(nir)) {
		return 'Non affilié au régime d\'assurance maladie français';
	} else if (assure) {
		return isFeminin ? 'Assurée' : 'Assuré';
	} else {
		return 'Ayant Droit';
	}
}

function getPatient(
	infosAssure: any,
	infosBenef: any,
	isFeminin: boolean,
	assure: boolean,
	nir: string) {
	return {
		prenom: infosBenef?.prenom !== '' ? infosBenef?.prenom : infosAssure?.prenom,
		nomFamille: infosBenef?.nomFamille !== '' ? infosBenef?.nomFamille : infosAssure?.nomFamille,
		nomUsage: infosBenef?.nomUsage !== '' ? infosBenef?.nomUsage : infosAssure?.nomUsage,
		isFeminin,
		dateNaissance: infosBenef?.dateNaissance !== '' ? infosBenef?.dateNaissance : infosAssure?.dateNaissance,
		assure,
		nir,
		patientStatus: getPatientStatut(nir, assure, isFeminin)
	};
}

export const getters: GetterTree<InfosPSBENState, RootState> = {
	getInfosPSBEN(state) {
		return state.infosPSBEN;
	},
	getErrorInfosPSBEN(state) {
		return state.error;
	},
	getLoaded(state) {
		return state.loaded;
	}
};

export const infosPSBEN: Module<InfosPSBENState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
